export default class InputAudioEffects {

  constructor(inputStream,meterCallback){
    this.ctx = new (window.AudioContext || window.webkitAudioContext) ();

    this.inputStream = inputStream;
    this.meterCallback = meterCallback;
    this.destination = undefined;
 
    this.gainNode = new GainNode(this.ctx);
    this.gainNode.gain.value = 1.0; // 0dB

    this.getOutputStream = this.getOutputStream.bind(this);
    this.setGain = this.setGain.bind(this);
    this.applyEffect = this.applyEffects.bind(this);
    this.close = this.close.bind(this);
    this.loop = this.loop.bind(this);

    console.log(this.constructor.name, 'In track-id:',  
      inputStream.getAudioTracks()[0].id);

    this.applyEffect();
  }

  getOutputStream() {
    if(this.destination){ 
      console.log(this.constructor.name, 'Out track-id:',  
      this.destination.stream.getAudioTracks()[0].id);
      return this.destination.stream;
    } else return null;
  }

  setGain(gain){
    this.gainNode.gain.value = Math.pow(10,gain/20); // dB
  }

  close(){
    this.ctx.close(); 
  }

  applyEffects(){
    this.ctx.resume();

    const source = this.ctx.createMediaStreamSource(this.inputStream);
    this.destination = this.ctx.createMediaStreamDestination();
    this.analyserNode = new AnalyserNode(this.ctx, {fftSize: 2048});

    source.connect(this.gainNode);
    this.gainNode.connect(this.destination);
    this.gainNode.connect(this.analyserNode);

//  this.gainNode.connect(this.ctx.destination); // local monitor

    this.loop();
  }


/* Reference
 https://stackoverflow.com/questions/44360301/web-audio-api-creating-a-peak-me ter-with-analysernode 
*/
  loop(){
    const sampleBuffer = new Float32Array(this.analyserNode.fftSize);

    this.analyserNode.getFloatTimeDomainData(sampleBuffer);
    let peakPower = 0; 
    for (let i=0; i < sampleBuffer.length; i++)
        peakPower = Math.max(sampleBuffer[i]**2, peakPower);

    const peakPowerDB = Math.max(-100, 10*Math.log10(peakPower));

    this.meterCallback(peakPowerDB); // peakPowerDB

    requestAnimationFrame(this.loop);
  } //end loop()

};
